var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "668px",
    height: "334px",
    viewBox: "0 0 668 334",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "battery-charging-svgrepo-com") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "battery-charging-svgrepo-com",
    transform: "translate(34.000000, 34.000000)",
    stroke: "currentColor",
    strokeWidth: 66.6666667
  }, /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 100,
    x2: 600,
    y2: 166.666667,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,0 L296.173333,5.10433333 L204.062667,127.916667 L202.437667,130.083333 C201.433333,131.423333 202.388667,133.333333 204.062667,133.333333 L204.062667,133.333333 L327.023333,133.333333 L327.023333,133.333333 C329.623333,133.333333 331.106667,136.303333 329.546667,138.383333 L327.023333,141.75 L238.566667,259.69 L233.333333,266.666667",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.666667,266.666667 L433.333333,266.666667 L433.333333,266.666667 C470.153333,266.666667 500,236.82 500,200 L500,66.6666667 C500,29.8476667 470.153333,0 433.333333,0 L433.333333,0 L400,0",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.333333,266.666667 L66.6666667,266.666667 L66.6666667,266.666667 C29.8476667,266.666667 0,236.82 0,200 L0,66.6666667 C0,29.8476667 29.8476667,0 66.6666667,0 L66.6666667,0 L166.666667,0",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/Battery.750b2950453858f2a5b7ab6e6a5907e3.svg";
export { ForwardRef as ReactComponent };